/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire;
};


async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
}) {
  try {
  } catch (e) {
    console.log('Endorsement Types:  - handleQuestionChange - error', e);
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
};

export { events };
